var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationActiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.488,
    height: 20,
    viewBox: "0 0 17.488 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1230",
    "data-name": "Group 1230",
    transform: "translate(-1191 -27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(1191 27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M15.405,17.273H.95a.931.931,0,0,1-.879-.584.913.913,0,0,1,.212-1.013l1.229-1.2V8.87a6.457,6.457,0,0,1,1.5-4.123A6.7,6.7,0,0,1,6.753,2.493V1.4a1.429,1.429,0,0,1,2.858,0V2.493c.105.022.2.045.293.069a4.5,4.5,0,0,0,4.949,6.972v4.938l1.229,1.2a.91.91,0,0,1,.212,1.01A.94.94,0,0,1,15.405,17.273Z",
    transform: "translate(0 0)",
    fill: "#203662"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M1.818,1.818A1.817,1.817,0,0,0,3.636,0H0A1.817,1.817,0,0,0,1.818,1.818Z",
    transform: "translate(6.364 18.182)",
    fill: "#203662"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(1200.488 28.196)",
    fill: "#ffc000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationActiveIcon);
export default __webpack_public_path__ + "static/media/notification-active-icon.4b4644c42cb314d711c793b871c44a6d.svg";
export { ForwardRef as ReactComponent };